export type ProcurementReferenceRoute =
  | 'requisition'
  | 'rfq-management'
  | 'purchase-orders'
  | 'goods-receipt'

export type ProcurementReferenceLink = {
  pathname: string
  search: string
  label: string
}

const entityRouteMap: Record<string, {route: ProcurementReferenceRoute; param: string}> = {
  REQUISITION: {route: 'requisition', param: 'requisitionId'},
  RFQ: {route: 'rfq-management', param: 'rfqId'},
  REQUEST_FOR_QUOTATION: {route: 'rfq-management', param: 'rfqId'},
  PURCHASE_ORDER: {route: 'purchase-orders', param: 'poId'},
  GOODS_RECEIPT: {route: 'goods-receipt', param: 'goodsReceiptId'},
  GOODS_RECEIPT_NOTE: {route: 'goods-receipt', param: 'goodsReceiptId'},
  GR: {route: 'goods-receipt', param: 'goodsReceiptId'},
}

export const resolveProcurementReferenceLink = (input: {
  entityName?: string | null
  entityId?: number | null
  referenceNo?: string | null
}): ProcurementReferenceLink | null => {
  const entityKey = String(input.entityName || '').trim().toUpperCase()
  const entityId = Number(input.entityId || 0)
  if (!entityKey || !Number.isFinite(entityId) || entityId <= 0) {
    return null
  }
  const routeConfig = entityRouteMap[entityKey]
  if (!routeConfig) {
    return null
  }

  const params = new URLSearchParams()
  params.set(routeConfig.param, String(entityId))

  return {
    pathname: `/procurement/${routeConfig.route}`,
    search: `?${params.toString()}`,
    label: input.referenceNo || `${entityKey}-${entityId}`,
  }
}
